module.exports = __webpack_public_path__ + "img/h_yuntuhui.fc01e5c5.png";